import { FormEvent, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import { useMobileLoginMutation } from "store/api/mobileApi"

import { setMobileAuthToken } from "utils/mobileAuthToken"
import { AuthForm } from "components/form/AuthForm"
import { Button } from "components/form/Button"
import { Input } from "components/form/Input"
import signInStyles from "pages/common/Auth/SignIn/index.module.scss"

const inputValuesInitialState = {
  email: "",
  password: "",
}

export const OAuthLogin = () => {
  const [triggerLogin, { isLoading }] = useMobileLoginMutation()
  const [inputValues, setInputValues] = useState(inputValuesInitialState)
  const location = useLocation()
  const navigate = useNavigate()

  const onInputChange = (event: FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget

    setInputValues(prevState => {
      return { ...prevState, [name]: value }
    })
  }

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    try {
      const res = await triggerLogin({
        mail: inputValues.email,
        password: inputValues.password,
      }).unwrap()

      if (res.token) {
        setMobileAuthToken(res.token)
        toast.success("Login successful")
        setInputValues(inputValuesInitialState)
        navigate({ pathname: "/oauth/devices", search: location.search }, { replace: true })
      }
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Login failed. Please check your credentials and try again."
      toast.error(message)
    }
  }

  return (
    <AuthForm title="Log In" subtitle="Welcome back! Please enter your details." onSubmit={onSubmit}>
      <Input label="Email" placeholder="Enter email" name="email" value={inputValues.email} onChange={onInputChange} />
      <Input
        label="Password"
        placeholder="Enter password"
        inputType="password"
        name="password"
        value={inputValues.password}
        onChange={onInputChange}
      />
      <div className={signInStyles.authButtonsWrapper}>
        <Button type="submit" color="colored" size="fullWidth" disabled={isLoading}>
          {isLoading ? "Logging in..." : "Log in"}
        </Button>
      </div>
    </AuthForm>
  )
}
